import * as React from 'react';
import './index.css';
import {Link, useParams} from "react-router-dom";
import {APP_LANDING, APP_LOGOUT_PATH, Client, EsignDocument, LegacyDocument} from "../../types";
import {FormEvent, useEffect, useRef, useState} from "react";
import {
    getClient, getClientPublic,
    getDocumentKey, getDocumentKeyPublic,
    getEsignDocument,
    getEsignProfiles, getEsignProfilesPublic, getFile, getFilePublic,
    getLegacyDocument, getLegacyDocumentPublic,
    getTemplates
} from "../../api";
import ExportPdfDocument from "../ExportPdfDocument";
import {useLocation} from "react-router";
import {signInClientFile} from "../../Auth";


const ExportClientFilePublic: React.FunctionComponent = () => {
    const {clientId} = useParams();
    const [client, setClient] = useState<Client>();
    const [esignDocuments, setEsignDocuments] = useState<EsignDocument[]>([]);
    const [legacyDocuments, setLegacyDocuments] = useState<LegacyDocument[]>([]);
    const [imageUploads, setImageUploads] = useState<string[]>([]);
    const [accessToken, setAccessToken] = useState();
    const [authFailure, setAuthFailure] = useState(false);
    const [authCode, setAuthCode] = useState();
    const [filePassword, setFilePassword] = useState();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const key = (queryParams.get("key") || "");

    useEffect(() => {
        if(authCode !== undefined) {
            signInClientFile(clientId, key, authCode)
                .then((o) => {
                    setAccessToken(o.access_token);
                }).catch((e) => {
                setAuthFailure(true);
            })
        }
    }, [authCode]);

    useEffect(() => {
        if (accessToken !== undefined) {
            getClientPublic(clientId, accessToken)
                .then((c) => {
                    setClient(c);
                });
        }
    }, [accessToken]);

    useEffect(() => {
        if (client !== undefined) {
            getEsignProfilesPublic(accessToken)
                .then((ps) => {
                    let profile = ps.filter((p) => p.name === "Promises12")[0];
                    client?.documents.forEach((d) => {
                        if (d.type.toLowerCase() === "upload") {


                            try {
                                getFilePublic(d.url, accessToken)
                                    .then((r) => {
                                        if (r.ok) {
                                            return r.blob();
                                        }
                                    })
                                    .then((blob) => new Promise(callback => {
                                        if (blob !== undefined) {
                                            let reader = new FileReader();
                                            reader.onload = function () {
                                                let dataUrl = this.result + "";
                                                if (d.url !== undefined && d.url.toLowerCase().endsWith(".pdf")) {
                                                    esignDocuments.push({
                                                        name: d.name,
                                                        fields: [],
                                                        status: d.status,
                                                        template: {
                                                            name: d.name,
                                                            url: dataUrl,
                                                            fields: []
                                                        }
                                                    });
                                                    setEsignDocuments([...esignDocuments]);
                                                } else {
                                                    imageUploads.push(dataUrl);
                                                    setImageUploads([...imageUploads]);
                                                }
                                            };
                                            reader.readAsDataURL(blob);
                                        }
                                    }));

                            } catch (e) {

                            }

                        }
                        if (d.type.toLowerCase() === "form" || d.type.toLowerCase() === "note") {
                            const docValues = d.url.substring(d.url.indexOf("/s/")).split("/");
                            const esignDocumntId = docValues[3];
                            getDocumentKeyPublic(profile.uuid, esignDocumntId, accessToken)
                                .then((k) => {
                                    getEsignDocument(esignDocumntId, profile.uuid, k.uuid)
                                        .then((ed) => {
                                            esignDocuments.push(ed);
                                            setEsignDocuments([...esignDocuments]);

                                        })
                                });
                        }
                    })
                })

            ///

            client.legacyDocuments.forEach((ld) => {
                getLegacyDocumentPublic(ld.id, accessToken)
                    .then((ld) => {
                        legacyDocuments.push(ld);
                        setLegacyDocuments([...legacyDocuments])
                    })

            })
        }
    }, [client]);

    const onSubmit = (e: FormEvent) => {
        e.preventDefault();
        setAuthCode(filePassword);
    }

    return (authCode === undefined) ? <>
            <form onSubmit={onSubmit}>
                <p>Enter last four of driver's license number</p>
                <input maxLength={4} placeholder={"0000"} type={"text"} value={filePassword} onChange={(e) => {
                    setFilePassword(e.target.value);
                }}/>
                <button type={"submit"}>Submit</button>
            </form>
        </> :
        ((client === undefined) ?
            (authFailure) ? <>Invalid or expired link</> : <>...Loading...</>
            : <>
                <div className={"page export-file"} style={{width: '100%', height: 1054}}>
                    <h3>Client Information</h3>
                    <h6>Full Name</h6>
                    {client?.firstName + " " + client?.lastName}
                    <h6>Client Id</h6>
                    {client?.id}
                    <h6>Balance</h6>
                    {client?.balance}
                    <h6>Absences</h6>
                    {client?.absences}
                    <h6>Total Hours Attended</h6>
                    {client?.totalHoursAttended}
                    <h6>Recommended Hours</h6>
                    {client?.recommendedHours}
                    <h6>Email</h6>
                    {client?.email}
                    <h6>Date of Birth</h6>
                    {client?.dateofBirth}
                    <h6>Date and Time of Assessment</h6>
                    {client?.dateTimeofAssessment}
                    <h6>Drivers License Number</h6>
                    {client?.driverslicenseNumber}
                    <h6>Drivers License State</h6>
                    {client?.driverslicenseState}
                    <h6>Social Security</h6>
                    {client?.socialsecurityNumber}
                    <h6>Telephone</h6>
                    {client?.telephoneNumber}
                    <h6>Address</h6>
                    {client?.address?.addressLine1 + " " + client?.address.addressLine2 + " " + client?.address.city + " " + client?.address.state + " " + client?.address.zip}
                    <h6>Email</h6>
                    {client?.email}
                    <h6>Transactions</h6>
                    <table>
                        <thead>
                        <tr>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Amount</th>
                            <th>Description</th>
                        </tr>
                        </thead>
                        <tbody>
                        {client?.transactions.map((t) => (
                            <tr key={"t_" + t.uuid}>
                                <td>{t.createdAt}</td>
                                <td>{t.type}</td>
                                <td>{t.amount}</td>
                                <td>{t.description}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <h6>Therapy Session Attendance</h6>
                    <table>
                        <thead>
                        <tr>
                            <th>Date</th>
                            <th>Attended</th>
                        </tr>
                        </thead>
                        <tbody>
                        {client?.attendances.map((a, index) => (
                            <tr key={"at_" + index}>
                                <td>{a.therapySession.date}</td>
                                <td>{a.attended ? "Yes" : "No"}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <div className="pagebreak"></div>
                {
                    esignDocuments.map((d) => (
                        <>
                            <ExportPdfDocument ed={d}/>
                        </>
                    ))
                }
                {
                    legacyDocuments.map((ld) => (
                        <div key={"ld_" + ld.id}>
                            {
                                ld?.pages.map((p) => (
                                    <div key={"p_" + p.number}>
                                        <div className={"document-wrapper"}
                                             style={{position: "relative", width: p.width, height: p.height}}>
                                            {
                                                p.fields.map((f) => (
                                                    <div key={"f_" + f.id}
                                                         style={{
                                                             fontSize: 12,
                                                             position: "absolute",
                                                             top: f.y,
                                                             left: f.x
                                                         }}>{f.value}</div>
                                                ))
                                            }

                                            <img src={p.imageData} width={p.width} height={p.height}/>
                                        </div>
                                        <div className="pagebreak"></div>
                                    </div>
                                ))
                            }
                        </div>
                    ))
                }
                {
                    imageUploads.map((i) => (
                        <>
                            <img alt={"upload"} src={i}/>
                            <div className="pagebreak"></div>
                        </>
                    ))
                }
            </>);
};

export default ExportClientFilePublic;